import { Box, Typography } from "@mui/material";
import * as React from "react";
import { TableSearch } from "./TableSearch";

interface PersistentSearchHeaderProps {
    title: string;
    actions?: React.ReactNode;
}

export const PersistentSearchHeader = ({ 
    title, 
    actions 
}: PersistentSearchHeaderProps): React.ReactElement => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 16px',
            borderBottom: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.paper',
        }}
    >
        <Typography variant="h6">{title}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {actions}
            <TableSearch />
        </Box>
    </Box>
);